// src/components/button/UpdateAvailable.tsx

import { NotificationsTwoTone } from '@mui/icons-material'
import { IconButton, Tooltip, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'

import { getStorage } from '../../api'
import { useAppConfig, useAppVersion } from '../../hooks'

export const UpdateAvailable = () => {
  const { setAppConfig } = useAppConfig()
  const { data: appVersion } = useAppVersion() as {
    data: number
  }
  const theme = useTheme()
  const color = theme.palette.error.main

  const onClick = () =>
    setAppConfig(prev => ({ ...prev, showSettings: true, setupTab: 2 }))

  const wobbleAnimation = {
    '@keyframes pulse': {
      '0%': { transform: 'scale(1)' },
      '50%': { transform: 'scale(1.2)' },
      '100%': { transform: 'scale(1)' },
    },
    animation: 'pulse 1.5s infinite',
    color,
  }

  const buildInfo = getStorage('buildInfo') || {
    environment: '',
    build: '',
    branch: '',
    commit_hash: '',
  }

  const [isOutdated, setIsOutDated] = useState(false)

  useEffect(() => {
    const checkVersion = () => {
      const latest = appVersion
      const current = Date.parse(buildInfo.build)

      setIsOutDated(current < latest)
    }

    checkVersion()
  }, [appVersion, buildInfo.build])

  return isOutdated ? (
    <Tooltip title={'Aktualisierung verfügbar'} arrow>
      <IconButton onClick={onClick}>
        <NotificationsTwoTone sx={wobbleAnimation} />
      </IconButton>
    </Tooltip>
  ) : null
}
